import React from 'react';
import {Link} from 'react-router-dom';
import QuantitySelectorMobile from '../commons/quantity-selector/QuantitySelectorMobile';
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'

const ProductList = ({products, billDetails, onChangeProductQuantity, onDeleteProduct, viewMode, order}) => {

  console.log("PRODUCT_LIST_MOBILE", products);

  return (
    <div className="product-list-mobile">
      <div className="section-header">Products</div>
      <div className="product-list">
        {products && products.map((p, idx) => {
          const product = {...p};
          // sort by quantity in descending
          const discounts = product.QuantityDiscount
            .sort((a, b) => b.quantity - a.quantity);
      
          if (discounts && discounts.length > 0) {
            product.bundledDiscount = product.QuantityDiscountOddItems ?
            discounts.filter(d =>
              d.quantity <= product.quantity) ?
                discounts.filter(d => d.quantity <= product.quantity)[0]
                : undefined
              : discounts.find(d => d.quantity === product.quantity);
      
            if (product.bundledDiscount) {
              product.SalePrice = product.bundledDiscount.priceB;
              product.bundle = true;
            } else {
              product.bundle = false;
            }
          }


          if (order && order.productsPriceHistory && order.productsPriceHistory.length) {
            product.priceHistory = order.productsPriceHistory.find((p) => {
              return p._id == product._id;
            });
          }

          return (
            <div className="list-item" key={`product_${idx}`}>
              <div className="list-item-image">
                <img src={product.image ? product.image : ProductDefaultImage} onError={(e) => {
                  return e.target.src = ProductDefaultImage
                }}/>
              </div>
              <div className="list-item-content">
                <div className="list-item-title">{product && product.Description ? product['Sub Description 2'] ? product['Sub Description 3'] ? product.Description + ' ' + product['Sub Description 2'] + ' ' + product['Sub Description 3']:product.Description + ' ' + product['Sub Description 2']: product.Description:''}</div>
                {product && product['Size'] ? (<div className="list-item-subtitle">{product['Size']}</div>) : null}
              </div>
              <div className="list-item-content-right">

                {!(order && product.priceHistory) ? <div className="list-item-title">
                  {product.PriceB && !(product.OnSale || product.bundle)
                      ? `$${ parseFloat(product.PriceB).toFixed(2)}`
                      : ''}
                  {product.PriceB && (product.OnSale || product.bundle)
                      ? <span><s>{`$${ parseFloat(product.PriceB).toFixed(2)}`}</s> {`$${ parseFloat(product.SalePrice).toFixed(2)}`}</span>
                      : ''}
                </div>:
                  (product.priceHistory['OnSale'] || product.priceHistory['bundle']) ?
                  <span>
                    <s>{`$${(parseFloat(product.priceHistory['PriceB'] )).toFixed(2)}`}</s>
                    {` $${(parseFloat(product.priceHistory['SalePrice'] )).toFixed(2)}`}
                  </span>
                  :
                  <span>
                    {`$${(parseFloat(product.priceHistory['PriceB'] )).toFixed(2)}`}
                  </span>
                }
                {viewMode && viewMode === 'edit'
                  ? (<QuantitySelectorMobile
                      quantity={product.quantity ? product.quantity : 0}
                      onChangeQuantity={(qty) => onChangeProductQuantity(product, qty)}
                      minimumQuantity={1}/>)
                  : (
                    <div className="list-item-title quantity">{product.quantity}</div>
                  )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/cart/ProductListMobile.js